<template>
  <v-container fluid class="full-container historic-container">
    <v-row class="tabs-root">
      <v-toolbar flat fixed class="tabs-toolbar">
        <v-tabs
          v-model="tab"
          grow
          show-arrows
        >
          <v-tabs-slider/>
          <v-tab :href="`#${tabs()[0]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.historic.pages.orders.icon }}</v-icon>
            {{ lang.meta.pages.historic.pages.orders.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[1]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.historic.pages.catalog.icon }}</v-icon>
            {{ lang.meta.pages.historic.pages.catalog.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[2]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.historic.pages.customers.icon }}</v-icon>
            {{ lang.meta.pages.historic.pages.customers.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[3]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.historic.pages.graphs.icon }}</v-icon>
            {{ lang.meta.pages.historic.pages.graphs.title }}
          </v-tab>
        </v-tabs>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-tabs-items v-model="tab">
          <v-tab-item :id="tabs()[0]">
            <Orders />
          </v-tab-item>
          <v-tab-item :id="tabs()[1]">
            <Catalog />
          </v-tab-item>
          <v-tab-item :id="tabs()[2]">
            <Customers />
          </v-tab-item>
          <v-tab-item :id="tabs()[3]">
            <Soon />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Orders from '@/components/historic/orders/Orders'
import Catalog from '@/components/historic/catalog/Catalog'
import Customers from '@/components/historic/customers/Customers'
import Soon from '@/components/utils/Soon'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import tabs from '@/mixins/defaults/tabs'

export default {
  components: { Orders, Catalog, Customers, Soon },
  mixins: [ appdata, utils, tabs ],
  data () {
    return {
      tabs: function () {
        return [
          this.lang.meta.pages.historic.pages.orders.path,
          this.lang.meta.pages.historic.pages.catalog.path,
          this.lang.meta.pages.historic.pages.customers.path,
          this.lang.meta.pages.historic.pages.graphs.path
        ]
      }
    }
  },
  created () {
    this.$store.dispatch('socket/CUSTOM_DATA', { ...this.get_global.filters })
  }
}
</script>

<style src="@/components/historic/styles/index.scss" lang="scss"></style>
